export interface Package {
  id: string;
  name: string;
  sub: string;
  price: string;
  per: string;
  best: string;
  hot?: boolean;
  inc: string[];
  out?: string;
}

export const SOCIAL: Package[] = [
  {
    id: "revbase",
    name: "RevBase",
    sub: "Build Your Presence",
    price: "$1,000 – $1,200",
    per: "/month",
    best: "Small businesses starting out",
    inc: [
      "Social media strategy (basic)",
      "8 posts/month (static + captions)",
      "Basic creative design",
      "Content scheduling & publishing",
      "Profile optimization",
      "Monthly performance report",
    ],
    out: "Show up online professionally and consistently.",
  },
  {
    id: "revboost",
    name: "RevBoost",
    sub: "Accelerate Your Growth",
    price: "$2,000 – $2,500",
    per: "/month",
    best: "Businesses ready to grow leads",
    hot: true,
    inc: [
      "Advanced strategy & content planning",
      "12–16 posts/month (incl. Reels)",
      "High-quality creative design",
      "Caption & hashtag optimization",
      "Community management (comments & DMs)",
      "Meta ads management (basic campaigns)",
      "Growth optimization",
      "Monthly reporting + strategy call",
    ],
    out: "Consistent, growing reach and new customers weekly.",
  },
  {
    id: "revmax",
    name: "RevMax",
    sub: "Dominate Your Market",
    price: "$3,800 – $5,000+",
    per: "/month",
    best: "Scaling brands & serious growth",
    inc: [
      "Full social strategy + funnel alignment",
      "20–30 content pieces/month (incl. video)",
      "Premium creative & video production",
      "Daily content management",
      "Full community management",
      "Advanced Meta ads (scaling + retargeting)",
      "Influencer / UGC campaigns",
      "Weekly optimization + reporting",
      "Dedicated account manager",
    ],
    out: "Become the most visible, trusted business in your category.",
  },
];

export const AUTO: Package[] = [
  {
    id: "revflow",
    name: "RevFlow",
    sub: "Streamline Your Operations",
    price: "$1,200 – $1,800",
    per: "/month",
    best: "Businesses starting automation",
    inc: [
      "Basic CRM setup",
      "Lead capture system",
      "1–2 automation workflows",
      "Email follow-up setup (basic)",
      "Appointment booking integration",
      "Monthly system check",
    ],
    out: "No more lost leads. Automatic follow-ups 24/7.",
  },
  {
    id: "revsync",
    name: "RevSync",
    sub: "Connect & Optimize Your Systems",
    price: "$2,500 – $3,500",
    per: "/month",
    best: "Growing businesses needing efficiency",
    hot: true,
    inc: [
      "Advanced CRM customization",
      "Multi-step automation workflows",
      "Email & SMS automation",
      "Sales pipeline setup",
      "Tool integrations (Zapier/API)",
      "Basic dashboard & reporting",
      "Monthly optimization",
    ],
    out: "Your business runs smoother. Close deals, don't chase them.",
  },
  {
    id: "revops",
    name: "RevOps",
    sub: "Automate & Scale Your Business",
    price: "$4,500 – $6,500+",
    per: "/month",
    best: "Scaling companies & high-ticket services",
    inc: [
      "Full business automation system",
      "Advanced CRM + pipeline management",
      "AI chatbot & lead qualification",
      "Full funnel automation",
      "Custom integrations",
      "Advanced analytics dashboard",
      "Ongoing optimization & support",
      "Dedicated automation specialist",
    ],
    out: "Your business operates like a machine. Hands-free growth.",
  },
];

export const WEB: Package[] = [
  {
    id: "revsite-core",
    name: "RevSite Core",
    sub: "Launch Your Digital Presence",
    price: "$1,500 – $2,500",
    per: "one-time",
    best: "Getting started with a professional presence",
    inc: [
      "3–5 page website",
      "Basic UI/UX design",
      "Mobile responsive",
      "Basic SEO setup",
      "Contact form integration",
    ],
    out: "A clean, credible website that builds trust.",
  },
  {
    id: "revsite-growth",
    name: "RevSite Growth",
    sub: "Built for Conversion",
    price: "$3,000 – $5,000",
    per: "one-time",
    best: "Converting visitors into customers",
    hot: true,
    inc: [
      "5–10 pages",
      "Conversion-focused design",
      "Landing pages",
      "Speed optimization",
      "On-page SEO",
      "Analytics setup",
    ],
    out: "A website that actively generates leads.",
  },
  {
    id: "revsite-pro",
    name: "RevSite Pro",
    sub: "High-Performance Web System",
    price: "$6,000 – $10,000+",
    per: "one-time",
    best: "Full custom web + funnel system",
    inc: [
      "Custom design & development",
      "Advanced UX/UI",
      "Funnel-based structure",
      "CRM & automation integrations",
      "Advanced SEO setup",
      "Performance optimization",
    ],
    out: "Your most powerful salesperson, working 24/7.",
  },
];
